import {createBackendEditor, referenceActionData} from '../../form/ComponentEditor';
import OperationListEditor from './OperationListEditor';
import {CurrencyFormatter, ProductColumn, UnitFormatter} from "../../../utils/formatters";
import {postData} from "../../../utils/request";
import React, {Fragment} from "react";
import TextInput from "../../form/TextInput";
import {ifCompletedInput, isTrue} from "../../../utils/other";
import RoyaltiesForm from "./Elements/RoyaltiesForm";
import Button from "../../form/Button";
import debounce from "lodash-es/debounce";
import {PriceView} from "../../classes/Price";
import CheckBox from "../../form/CheckBox";
import Select from "../../form/Select";
import ImportButton from "../../form/ImportButton";

const sortable = true;
const filterable = true;

const percentColors = [
    {pct: 0.0, color: {r: 216, g: 218, b: 255}},
    {pct: 0.5, color: {r: 245, g: 221, b: 187}},
    {pct: 1.0, color: {r: 255, g: 160, b: 160}}];

const getColorForPercentage = function (pct) {
    let i = 1;
    for (; i < percentColors.length - 1; i++) {
        if (pct < percentColors[i].pct) {
            break;
        }
    }
    let lower = percentColors[i - 1];
    let upper = percentColors[i];
    let range = upper.pct - lower.pct;
    let rangePct = (pct - lower.pct) / range;
    let pctLower = 1 - rangePct;
    let pctUpper = rangePct;
    let color = {
        r: Math.floor(lower.color.r * pctLower + upper.color.r * pctUpper),
        g: Math.floor(lower.color.g * pctLower + upper.color.g * pctUpper),
        b: Math.floor(lower.color.b * pctLower + upper.color.b * pctUpper)
    };
    return 'rgb(' + [color.r, color.g, color.b].join(',') + ')';
    // or output as hex if preferred
}

class RoyaltiesEditor extends React.Component {

    state = {
        componentEditor: "Royalties",
        hoverColumnValue: null,
        filter: [
            {column: "preset", value: "Royalties"},
            {column: "saved", value: 1}
        ],
        labels: {target: "Telephely"},
        actionButtons: [],
        pool: {
            exports: [{as: "excel", label: "Excel", icon: "far fa-file-excel"}],
            //orderBy: {field: "object_component.displayname", direction: "ASC"},
            selection: [],
            pageSize: 5,
            pageSizes: [5,10,15,20,50],
            aggregations: {
                fields: {
                    "listprice_net_total": {
                        field: "listprice_net_total", type: "SUM"
                    },
                    "listprice_gross_total": {
                        field: "listprice_gross_total", type: "SUM"
                    },
                    "saleprice_net_total": {
                        field: "saleprice_net_total", type: "SUM"
                    },
                    "saleprice_gross_total": {
                        field: "saleprice_gross_total", type: "SUM"
                    },
                }
            },
            component: "Royalty",
            placeholder: "Keresés, hozzáadás...",
            autoSelect: false,
            labelKey: "object_component.displayname",
            storeType: "remote",
            onSourceItemUpdate: (value) => {
                value = {...value};
                value.component_type = "Royalty";
                value.component_id = value.id;
                value.listprice = 0;
                value.saleprice = 0;
                delete value.id;
                return value;
            },
            label: false,
            view: ["id","OperationList_id", "vat", "component_type", "component_id", ...PriceView("saleprice"), "saleprice", ...PriceView("listprice"), "listprice", "qty"],
            columns: {
                "object_component.displayname": {
                    header: 'Megnevezés',
                    width: 9,
                    sortable,
                    filterable,
                },
                "saleprice_net_total": {
                    header: 'Nettó összeg',
                    width: 1,
                    renderer: CurrencyFormatter,
                    className: "currency",
                    editor:
                        (parent) =>
                            (props, value) =>
                                <TextInput type="decimal" name="saleprice_net_total" label={false} focus="focus"
                                           value={value}
                                           onKeyDown={(e, field, value) => {
                                               ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                           }}
                                           onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/>
                },
                "vat": {
                    header: "Áfa",
                    width: "vat",
                    renderer: (value) => <span className="vat">{value.name}</span>,
                    editor:
                        (parent) =>
                            (props, value) =>
                                <Select
                                    name="vat"
                                    component="vatrate"
                                    filter={{field: "active", value: 1}}
                                    objectValue={true}
                                    label={false}
                                    storeType="local"
                                    value={value}
                                    view={["rate"]}
                                    saveChanges={(field, value) => {
                                        parent.onEditorValueChange(props, value);
                                    }}
                                />
                },
                "saleprice_gross_total": {
                    header: 'Bruttó összeg',
                    width: 1,
                    renderer: CurrencyFormatter,
                    className: "currency",
                    editor:
                        (parent) =>
                            (props, value) =>
                                <TextInput type="decimal" name="saleprice_gross_total" label={false} focus="focus"
                                           value={value}
                                           onKeyDown={(e, field, value) => {
                                               ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                                           }}
                                           onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/>
                }
            }
        }
    };

    promisedSetState = (newState) => {
        return new Promise((resolve) => {
            this.setState(newState, () => {
                resolve()
            });
        });
    }

    constructor(props) {
        super(props);
        this.hoverDebounce = debounce((value) => {
            this.setState({hoverColumnValue: value});
        }, 300);
    }

    getProps = () => {
        const props = {
            ...this.props,
            ...this.state,
        };
        props.actionButtons = [
            <Button key="4" disabled={ props.isLoading || !props.values.id } color="primary" icon={{lib: "fa", name: "file"}} className="pull-right" onClick={ async (e) => {
                const values = props.values;
                values.autocheckup = true;
                await props.processAction(async () => {
                    const response = await postData({
                        action: 'OperationList.doAction',
                        actionname: 'create',
                        data: await referenceActionData(values, this.props.componentConfig)
                    });
                    await this.props.pristineForm(false);
                    return response;
                });
            }}>
                Számla rögzítése
            </Button>
        ];
        props.pool.parameters = {};
        props.pool.reqparams = {};
        props.pool.filter = [];
        if (props.values && props.values.seller) {
            props.pool.visible = true;
            props.pool.parameters.reports = (this.props.values.xtradata || {}).reports;
            props.pool.parameters.OperationList_id = props.values.id;
            props.pool.filter = [...props.pool.filter, {field: "licensor.partner_id", value: props.values.seller.partner_id}];
        } else {
            props.pool.visible = false;
        }
        props.pool.visible = !((this.props.values.xtradata || {}).reports || []).length;
        return props;
    }

    formatOperationItems = (config) => {
        config.pageSize = 15;
        config.actions = true;
        config.selection = {};
        delete config.rowClassName;
        delete config.columns.barcode;
        delete config.columns.qty;
        delete config.columns.saleprice_gross;
        delete config.columns.listprice_gross;
        config.columns.saleprice_net_total = this.state.pool.columns.saleprice_net_total;
        config.columns.vat = this.state.pool.columns.vat;
        config.columns.saleprice_gross_total = this.state.pool.columns.saleprice_gross_total;
        delete config.columns.discount
        delete config.columns.displayname;
        config.columns['object_component.displayname'] = this.state.pool.columns['object_component.displayname'];
        config.columns = {
            ['object_component.displayname']: config.columns['object_component.displayname'],
            saleprice_net_total: config.columns.saleprice_net_total,
            vat: config.columns.vat,
            saleprice_gross_total: config.columns.saleprice_gross_total,
        }
        return config;
    }

    renderer = (componentProps) => {
        return <RoyaltiesForm {...componentProps} setSelectedReports={async (reports) => {
            await componentProps.props.setFieldValue("xtradata", {...this.props.values.xtradata,
                reports
            });
        }} />;
    }

    render() {
        const props = this.getProps();
        return <OperationListEditor {...props} renderer={this.renderer} formatOperationItems={this.formatOperationItems} />;
    }

}

export default createBackendEditor({
    componentName: "OperationList",
    WrappedComponent: RoyaltiesEditor,
    editor: "RoyaltyPayments",
    dirtyFlag: (values) => {
        return !parseInt(values.saved) && values.id;
    },
    props: {
        componentActions: async (action, data, params, componentConfig) => {
            params.preset = "Royalties";
            data = await referenceActionData(data, componentConfig);
            return {action,data,params};
        }
    }
});